import { Injectable } from '@angular/core';
import { SyncKeyValueStorageService } from '@shared/modules/storage/data-access/sync-key-value-storage.service';

/**
 * `localStorage`-backed {@link SyncKeyValueStorageService}. Works in both the web and Electron
 * renderer, which share the same Chromium storage. A deliberately thin pass-through: Web Storage
 * error semantics are part of the abstract contract, so nothing is caught here.
 */
@Injectable()
export class LocalStorageSyncKeyValueStorageService extends SyncKeyValueStorageService {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
